import { graphql } from '@/gql'

export const FeeFragment = graphql(/* GraphQL */ `
  fragment FeeFragment on Fee {
    id
    application
    formattedRate
  }
`)
